module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_right_light-1b3b0c304a276aafaeeac01abb4afe38.svg";